<template>
	<div v-if="show" class="existing-info-message">
		<p>
			<strong>✓ {{ message }}</strong>
		</p>
	</div>
</template>

<script>
	export default {
		name: 'OaoExistingInfoMessage',
		props: {
			show: {
				type: Boolean,
				required: true
			},
			message: {
				type: String,
				required: true
			}
		}
	};
</script>

<style scoped>
	.existing-info-message {
		p {
			margin-bottom: 1rem;
			padding: 0.75rem;
			background-color: #f8f9fa;
			border-left: 4px solid #28a745;
			color: #155724;
		}
	}
</style>
